import { Factory } from 'fishery'

import { BookingParty } from '../Incoterms/incotermsMeta'
import { IQuoteOption, QuoteSource } from '../QuoteSheet/QuoteSheetOption'

export const mockQuoteOption: IQuoteOption = {
  _id: '608a98da98d129844d872526',
  internalIndex: parseInt('608a98da98d129844d872526', 10),
  bookableUntil: new Date('2021-05-30T00:00:00.000Z'),
  bookingParty: 'buyer' as BookingParty,
  destinationCustomsQuote: {
    lineItems: [
      {
        type: 'customs',
        name: 'Customs',
        code: 'CCD',
        description: '',
        quantity: 1,
        unitPrice: { value: 43.5, code: 'EUR' },
        total: { value: 43.5, code: 'EUR' },
        currencyExchangeRateId: '608a8742f246153a29e85bf9',
        reference: ['rMfQgLktXL'],
        totalEUR: 43.5,
        exchangeRate: 1,
      },
    ],
    type: 'standard',
  },
  handlingFeeLineItem: {
    type: 'handling',
    name: 'Forto Handling Fee',
    code: 'FALLBACK',
    description: 'Our handling fee for your booking',
    quantity: 1,
    unitPrice: { value: 0, code: 'EUR' },
    total: { value: 0, code: 'EUR' },
    currencyExchangeRateId: '608a9ff248708a77daa2ec9a',
    reference: [],
    totalEUR: 0,
    exchangeRate: 1,
  },
  incoTerm: 'EXW',
  insuranceQuote: { lineItems: [] },
  isManual: true,
  routeQuotes: {
    preQuote: {
      lineItems: [
        {
          type: 'carriage',
          name: 'Truck Pre-Carriage',
          code: 'RAILRTO',
          description: '',
          quantity: 1,
          unitPrice: { value: 225, code: 'USD' },
          total: { value: 225, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: ['608922f3a6a40c85ba6079fb'],
          totalEUR: 189.32,
          exchangeRate: 1.1884950980392155,
        },
        {
          type: 'surcharge',
          name: 'Lifting Platform Surcharge at Origin',
          code: 'LIFTO',
          description: '',
          quantity: 1,
          unitPrice: { value: 43, code: 'USD' },
          total: { value: 43, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 36.18,
          meta: { chargeableWeight: 2475 },
          exchangeRate: 1.1884950980392155,
        },
      ],
      mode: 'truck',
      route: {
        carrier_id: 'KLCS',
        duration: 172800000,
        eta: new Date(''),
        etd: new Date(''),
        frequency: 'weekly',
        journey: {
          origin: {
            _id: 'ChIJDTGPBu6RBDQRHlYeDeZYznk',
            types: ['address'],
            location: { lat: 23.1109424, lng: 114.4167999 },
            street: '',
            street2: '',
            streetNumber: '',
            city: 'Huizhou',
            district: 'Huicheng District',
            state: '',
            country: 'China',
            countryCode: 'CN',
            fullAddress: '',
            postalCode: '516000',
            googlePlace: 'ChIJDTGPBu6RBDQRHlYeDeZYznk',
            description: '',
            googplace_id: '',
            googplace_types: [],
            place_id: '',
            locationId: '',
          },
          destination: {
            _id: 'CNCGO',
            name: 'Zhengzhou Xinzheng Terminal',
            countryCode: 'CN',
            types: ['rail'],
            location: { type: 'Point', coordinates: [113.8410034, 34.5196991] },
            aliases: [],
            locationAliases: [],
            isMainFor: [],
          },
        },
        scheduleReference: '',
        transportMode: 'truck',
        type: 'preRoute',
        segments: [
          {
            carrier_id: 'KLCS',
            duration: 172800000,
            eta: new Date(''),
            etd: new Date(''),
            journey: {
              origin: {
                _id: 'ChIJDTGPBu6RBDQRHlYeDeZYznk',
                types: ['address'],
                location: { lat: 23.1109424, lng: 114.4167999 },
                fullAddress: '',
                street: '',
                street2: '',
                streetNumber: '',
                city: 'Huizhou',
                district: 'Huicheng District',
                state: '',
                country: 'China',
                countryCode: 'CN',
                postalCode: '516000',
                googlePlace: 'ChIJDTGPBu6RBDQRHlYeDeZYznk',
                description: '',
                googplace_id: '',
                googplace_types: [],
                place_id: '',
                locationId: '',
              },
              destination: {
                _id: 'CNCGO',
                name: 'Zhengzhou Xinzheng Terminal',
                countryCode: 'CN',
                types: ['rail'],
                location: { type: 'Point', coordinates: [113.8410034, 34.5196991] },
                aliases: [],
                locationAliases: [],
                isMainFor: [],
              },
            },
            transportMode: 'truck',
            type: 'preRoute',
          },
        ],
      },
      additionalCharges: [],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
      rates: [{ _id: '608922f3a6a40c85ba6079fb', carrier_id: 'KLCS', contractNumbers: ['KLCS FAK May'] }] as any,
    },
    mainQuote: {
      lineItems: [
        {
          type: 'freight',
          name: 'Freight',
          code: 'RFREIGHT',
          description: '',
          quantity: 1,
          unitPrice: { value: 215, code: 'USD' },
          total: { value: 215, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: ['608922f3a6a40c5cfe607986'],
          totalEUR: 180.9,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1.1884950980392155,
        },
        {
          type: 'surcharge',
          name: 'Terminal Handling Charge',
          code: 'THCD',
          description: '',
          quantity: 1,
          unitPrice: { value: 170, code: 'EUR' },
          total: { value: 170, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 170,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1,
        },
        {
          type: 'surcharge',
          name: 'D/O Fee',
          code: 'DOCD',
          description: '',
          quantity: 1,
          unitPrice: { value: 30, code: 'EUR' },
          total: { value: 30, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 30,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1,
        },
        {
          type: 'surcharge',
          name: 'Documentation Fee',
          code: 'DOCD',
          description: '',
          quantity: 1,
          unitPrice: { value: 25, code: 'EUR' },
          total: { value: 25, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 25,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1,
        },
        {
          type: 'surcharge',
          name: 'Compliance Fee',
          code: 'ATCFD',
          description: '',
          quantity: 1,
          unitPrice: { value: 0, code: 'EUR' },
          total: { value: 0, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 0,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1,
        },
        {
          type: 'surcharge',
          name: 'Customs and Handling at Origin',
          code: 'CCO',
          description: '',
          quantity: 1,
          unitPrice: { value: 100, code: 'USD' },
          total: { value: 100, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 84.14,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1.1884950980392155,
        },
        {
          type: 'surcharge',
          name: 'Local Transport Fee',
          code: 'TRFO',
          description: '',
          quantity: 1,
          unitPrice: { value: 115, code: 'USD' },
          total: { value: 115, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 96.76,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1.1884950980392155,
        },
        {
          type: 'surcharge',
          name: 'Peak Season Surcharge',
          code: 'PSS',
          description: '',
          quantity: 1,
          unitPrice: { value: 30, code: 'USD' },
          total: { value: 30, code: 'USD' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 25.24,
          meta: { chargeableWeight: 416 },
          exchangeRate: 1.1884950980392155,
        },
        {
          type: 'handling',
          name: 'Forto Handling Fee',
          code: 'FHND',
          description: '',
          quantity: 1,
          unitPrice: { value: 50, code: 'EUR' },
          total: { value: 50, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 50,
          exchangeRate: 1,
        },
      ],
      mode: 'rail',
      route: {
        carrier_id: 'KLCS',
        cutOff: -2,
        daysOfDeparture: ['thu'],
        duration: 1468800000,
        eta: new Date(''),
        etd: new Date(''),
        frequency: 'weekly',
        journey: {
          origin: {
            _id: 'CNCGO',
            name: 'Zhengzhou Xinzheng Terminal',
            countryCode: 'CN',
            types: ['rail'],
            location: { type: 'Point', coordinates: [113.8410034, 34.5196991] },
            aliases: [],
            locationAliases: [],
            isMainFor: [],
          },
          destination: {
            _id: 'R-DEHAM',
            name: 'Hamburg Railway Station',
            active: true,
            countryCode: 'DE',
            cargoSmartAlias: 'R-DEHAM',
            unLocCode: 'R-DEHAM',
            types: ['rail'],
            location: { type: 'Point', coordinates: [10.100748, 53.513118] },
            aliases: [],
            locationAliases: [],
          },
        },
        scheduleReference: '',
        transportMode: 'rail',
        type: 'mainRoute',
        segments: [
          {
            carrier_id: 'KLCS',
            cutOff: -2,
            daysOfDeparture: ['thu'],
            duration: 1468800000,
            eta: new Date(''),
            etd: new Date(''),
            journey: {
              origin: {
                _id: 'CNCGO',
                name: 'Zhengzhou Xinzheng Terminal',
                countryCode: 'CN',
                types: ['rail'],
                location: { type: 'Point', coordinates: [113.8410034, 34.5196991] },
                aliases: [],
                locationAliases: [],
                isMainFor: [],
              },
              destination: {
                _id: 'R-DEHAM',
                name: 'Hamburg Railway Station',
                active: true,
                countryCode: 'DE',
                cargoSmartAlias: 'R-DEHAM',
                unLocCode: 'R-DEHAM',
                types: ['rail'],
                location: { type: 'Point', coordinates: [10.100748, 53.513118] },
                aliases: [],
                locationAliases: [],
              },
            },
            transportMode: 'rail',
            type: 'mainRoute',
          },
        ],
      },
      additionalCharges: [],
      source: QuoteSource.DEFAULT,
      rates: [],
    },
    postQuote: {
      lineItems: [
        {
          type: 'carriage',
          name: 'Truck On-Carriage',
          code: 'TRUCKRTD',
          description: '',
          quantity: 1,
          unitPrice: { value: 140, code: 'EUR' },
          total: { value: 140, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: ['608922f3a6a40c4f5160799f'],
          totalEUR: 140,
          exchangeRate: 1,
        },
        {
          type: 'surcharge',
          name: 'Lifting Platform Surcharge at Destination',
          code: 'LIFTD',
          description: '',
          quantity: 1,
          unitPrice: { value: 35, code: 'EUR' },
          total: { value: 35, code: 'EUR' },
          currencyExchangeRateId: '608a8742f246153a29e85bf9',
          reference: [],
          totalEUR: 35,
          meta: { chargeableWeight: 2475 },
          exchangeRate: 1,
        },
      ],
      mode: 'truck',
      route: {
        carrier_id: 'OETJE',
        duration: 172800000,
        eta: new Date(''),
        etd: new Date(''),
        frequency: 'weekly',
        journey: {
          origin: {
            _id: 'R-DEHAM',
            name: 'Hamburg Railway Station',
            active: true,
            countryCode: 'DE',
            cargoSmartAlias: 'R-DEHAM',
            unLocCode: 'R-DEHAM',
            types: ['rail'],
            location: { type: 'Point', coordinates: [10.100748, 53.513118] },
            aliases: [],
            locationAliases: [],
          },
          destination: {
            _id: 'EiBNw7xobGUgNjQsIDQwNzI0IEhpbGRlbiwgR2VybWFueSIwEi4KFAoSCR_v0nRjzbhHEV9ePH1E-5vmEEAqFAoSCY9EQOZizbhHEWxqAqFMvxVx',
            types: ['address'],
            location: { lat: 51.1701772, lng: 6.9438702 },
            street: 'Mühle',
            street2: '',
            streetNumber: '64',
            city: 'Hilden',
            district: '',
            state: 'Nordrhein-Westfalen',
            country: 'Germany',
            countryCode: 'DE',
            postalCode: '40724',
            fullAddress: '',
            googlePlace:
              'EiBNw7xobGUgNjQsIDQwNzI0IEhpbGRlbiwgR2VybWFueSIwEi4KFAoSCR_v0nRjzbhHEV9ePH1E-5vmEEAqFAoSCY9EQOZizbhHEWxqAqFMvxVx',
            description: '',
            googplace_id: '',
            googplace_types: [],
            place_id: '',
            locationId: '',
          },
        },
        scheduleReference: '',
        transportMode: 'truck',
        type: 'postRoute',
        segments: [
          {
            carrier_id: 'OETJE',
            duration: 172800000,
            eta: new Date(''),
            etd: new Date(''),
            journey: {
              origin: {
                _id: 'R-DEHAM',
                name: 'Hamburg Railway Station',
                active: true,
                countryCode: 'DE',
                cargoSmartAlias: 'R-DEHAM',
                unLocCode: 'R-DEHAM',
                types: ['rail'],
                location: { type: 'Point', coordinates: [10.100748, 53.513118] },
                aliases: [],
                locationAliases: [],
              },
              destination: {
                _id: 'EiBNw7xobGUgNjQsIDQwNzI0IEhpbGRlbiwgR2VybWFueSIwEi4KFAoSCR_v0nRjzbhHEV9ePH1E-5vmEEAqFAoSCY9EQOZizbhHEWxqAqFMvxVx',
                types: ['address'],
                location: { lat: 51.1701772, lng: 6.9438702 },
                street: 'Mühle',
                street2: '',
                fullAddress: '',
                streetNumber: '64',
                city: 'Hilden',
                district: '',
                state: 'Nordrhein-Westfalen',
                country: 'Germany',
                countryCode: 'DE',
                postalCode: '40724',
                googlePlace:
                  'EiBNw7xobGUgNjQsIDQwNzI0IEhpbGRlbiwgR2VybWFueSIwEi4KFAoSCR_v0nRjzbhHEV9ePH1E-5vmEEAqFAoSCY9EQOZizbhHEWxqAqFMvxVx',
                description: '',
                googplace_id: '',
                googplace_types: [],
                place_id: '',
                locationId: '',
              },
            },
            transportMode: 'truck',
            type: 'postRoute',
          },
        ],
      },
      additionalCharges: [],
      source: QuoteSource.DEFAULT,
      rates: [],
    },
  },
  sheet_id: '608a87950ff2df5657e95bd4',
  type: 'lcl',
  totalDuration: 2,
  mode: 'sea',
  totalEUR: 1023,
  isNotFak: false,
  lineItems: [],
  additionalCharges: [],
}

class QuoteOptionTestFactory extends Factory<IQuoteOption> {}

export const quoteOptionTestFactory = QuoteOptionTestFactory.define(() => ({
  ...mockQuoteOption,
}))
